import { styled } from '@mui/material';

import { AIResponse, formatExplanationPart } from '@app-velocity/common';

import { Typography } from '../Typography';

export type AiResponseExplanationProps = {
  response: AIResponse;
  variant?: 'compact' | 'default';
};

const StyledExplanation = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

const StyledExplanationPart = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ compact }) => ({
  fontWeight: 300,
  color: '#333',
  whiteSpace: 'pre-line',
  lineHeight: compact ? 1.3 : 1.4,
  fontSize: compact ? 12 : 14,
}));

export const AiResponseExplanation = ({
  response,
  variant = 'default',
}: AiResponseExplanationProps) => {
  return (
    <StyledExplanation>
      {response.explanation.split('||').map((part, index) => (
        <StyledExplanationPart
          key={index}
          variant="body2"
          compact={variant === 'compact'}
        >
          {formatExplanationPart(part, index)}
        </StyledExplanationPart>
      ))}
    </StyledExplanation>
  );
};
